module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-02.e2b2543a.png";